import {throttle} from "./Util";

const $wrapPage = $('.js-wrap-page');

/* Брекпоинты */
const desktopWidth = 1100;
const horTabletWidth = 1024;
const verTabletWidth = 768;

/* Кол-во клеток в строке (может быть дробным, если отступы в макете не "цельноклетные") */
const desktopCols = 24.3;
const horTabletCols = 17.3;
const verTabletCols = 13;
const mobileCols = 7.1;

App.W.on('resize', throttle(setColumns, 200));
setColumns();

function setColumns() {
    const windowWidth = App.D.outerWidth();
    let celWidth = mobileCols;

    if (windowWidth >= verTabletWidth) {
        celWidth = verTabletCols;
    }

    if (windowWidth >= horTabletWidth) {
        celWidth = horTabletCols;
    }

    if (windowWidth >= desktopWidth) {
        celWidth = desktopCols;
    }

    /* Записываем значение, чтобы потом использовать в переменных css */
    if ($wrapPage[0]) {
        $wrapPage[0].style.cssText = `--cell-count: ${celWidth}`;
        $wrapPage.data('cell-count', celWidth); 
    }
    
}



// WEBPACK FOOTER //
// ./_src/js/Grid.js